import { useMemo, useSyncExternalStore } from "react";
import { usePageContext } from "vike-react/usePageContext";
// src/navigation/hooks/client-route.ts
const subscribe = (callback) => {
	window.addEventListener("hashchange", callback);
	window.addEventListener("popstate", callback);
	return () => {
		window.removeEventListener("hashchange", callback);
		window.removeEventListener("popstate", callback);
	};
};
const getClientHash = () => window.location.hash;
const getServerHash = () => "";
const useClientRoute = () => {
	const { urlParsed: { pathname } } = usePageContext();
	const hash = useSyncExternalStore(subscribe, getClientHash, getServerHash).substring(1) || null;
	return useMemo(() => ({
		pathname,
		hash,
		pathnameWithHash: hash ? `${pathname}#${hash}` : pathname
	}), [pathname, hash]);
};
export { useClientRoute };

//# sourceMappingURL=client-route.js.map